import { render, staticRenderFns } from "./BrowsingHistoryExhibitors.vue?vue&type=template&id=0be64042&scoped=true&"
import script from "./BrowsingHistoryExhibitors.vue?vue&type=script&lang=js&"
export * from "./BrowsingHistoryExhibitors.vue?vue&type=script&lang=js&"
import style0 from "./BrowsingHistoryExhibitors.vue?vue&type=style&index=0&id=0be64042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be64042",
  null
  
)

export default component.exports